/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import "aisztheme";

import React from "react";
import startsWith from "lodash/startsWith";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import { Link } from "react-router";
import {
  Grid,
  Row,
  Col,
  Panel,
  Nav,
  NavItem,
  Table,
  Modal,
  Button,
  Badge,
} from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import Dropzone from "react-dropzone";
import Papa from "papaparse";
import CSSModules from "react-css-modules";
import Toolbar from "loracoms/Toolbar";
import ShowIf from "loracoms/ShowIf";
import HideIf from "loracoms/HideIf";
import InlineSelect from "loracoms/InlineSelect";
import Checkbox from "loracoms/Checkbox";
import IntlMsg from "lorautils/intl/IntlMsg";
import usageActions from "loraactions/usage";
import { importBatch } from "loraapi/lora_device";
import styles from "./styles.scss";

const kEncodingOptions = [
  {
    label: "UTF-8",
    value: "UTF-8",
  },
  {
    label: "GBK",
    value: "GBK",
  },
];

const kInnerFields = ["valid", "idx", "error", "result", "missings"];

const kRequiredFields = ["deveui", "band"];

const validateFields = {
  vendor: (v) => _.inRange(v, 0, 256) && _.isInteger(v),
  vendorver: (v) => _.inRange(v, 0, 256) && _.isInteger(v),
  rx2freq: (v) => _.inRange(v * 100, 100000, 1.67 * 10 ** 9) || v === 0,
};

const defaultProps = {
  app: {},
  basic: {},
  plan: {},
  usage: {},
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  app: React.PropTypes.object,
  basic: React.PropTypes.object,
  plan: React.PropTypes.object,
  usage: React.PropTypes.object,
  getNodesUsage: React.PropTypes.func.isRequired,
};

class BatchImport extends React.Component {
  static renderABPZhHelp() {
    return (
      <tbody>
        <tr>
          <td>deveui</td>
          <td>16位16进制</td>
          <td>必选</td>
          <td>终端EUI</td>
        </tr>
        <tr>
          <td>devaddr</td>
          <td>8位16进制</td>
          <td>必选</td>
          <td>终端LoRaWAN地址</td>
        </tr>
        <tr>
          <td>nwkskey</td>
          <td>32位16进制</td>
          <td>必选</td>
          <td>
            <strong>N</strong>et<strong>w</strong>or<strong>k</strong>{" "}
            <strong>S</strong>ession <strong>Key</strong>
          </td>
        </tr>
        <tr>
          <td>appskey</td>
          <td>32位16进制</td>
          <td>必选</td>
          <td>
            <strong>App</strong> <strong>S</strong>ession <strong>Key</strong>
          </td>
        </tr>
        <tr className={styles.new}>
          <td>
            band <strong className={styles.new}>新增!</strong>{" "}
          </td>
          <td>
            <ul className="list-unstyled">
              <li>CN470</li>
              <li>US902</li>
              <li>AU915</li>
              <li>EU863</li>
              <li>EU868SEMTECH</li>
              <li>CN470PREQUEL</li>
              <li>AS923</li>
            </ul>
          </td>
          <td>必选</td>
          <td>ISM频段</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendor <strong className={styles.new}>新增!</strong>{" "}
          </td>
          <td>整数</td>
          <td>可选</td>
          <td>厂商ID，范围0~255</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendorver <strong className={styles.new}>新增!</strong>{" "}
          </td>
          <td>整数</td>
          <td>可选</td>
          <td>厂商版本，范围0~255</td>
        </tr>
        <tr>
          <td>city</td>
          <td>string</td>
          <td>可选</td>
          <td>城市</td>
        </tr>
        <tr>
          <td>area</td>
          <td>string</td>
          <td>可选</td>
          <td>区域</td>
        </tr>
        <tr>
          <td>address</td>
          <td>string</td>
          <td>可选</td>
          <td>具体的地址</td>
        </tr>
        <tr>
          <td>lng</td>
          <td>string</td>
          <td>可选</td>
          <td>经度(-180.000000 ~ +180.000000)</td>
        </tr>
        <tr>
          <td>lat</td>
          <td>string</td>
          <td>可选</td>
          <td>纬度(-90.000000 ~ +90.000000)</td>
        </tr>
        <tr>
          <td>class</td>
          <td>string</td>
          <td>可选</td>
          <td>终端类型，A</td>
        </tr>
        <tr>
          <td>lwanver</td>
          <td>string</td>
          <td>可选</td>
          <td>协议版本, LoRaWAN1.0.1</td>
        </tr>
        <tr>
          <td>rxwindow</td>
          <td>number</td>
          <td>可选</td>
          <td>下行链路RX窗口选择 取值 1或2代表RX1或RX2</td>
        </tr>
        <tr>
          <td>name</td>
          <td>string</td>
          <td>可选</td>
          <td>设备名称</td>
        </tr>
        <tr>
          <td>type</td>
          <td>string</td>
          <td>可选</td>
          <td>前端app解释，温湿度传感器</td>
        </tr>
        <tr>
          <td>rx2dr</td>
          <td>number</td>
          <td>可选</td>
          <td>rx2速率</td>
        </tr>
        <tr>
          <td>rx2freq</td>
          <td>number</td>
          <td>可选</td>
          <td>rx2频点, 单位HZ/100</td>
        </tr>
        <tr>
          <td colSpan={4}>
            <h4>导入csv文件内容示例</h4>
            <code>
              deveui,devaddr,nwkskey,appskey,
              <strong className={styles.new}>band</strong>,
              city,area,address,lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver
              <br />
              9876987423569874,11169874,
              13569874235698742356987423569874,13569874235698742356987423569874,
              <strong className={styles.new}>CN470</strong>,
              深圳,南山,科技园,23,25,A,LoRaWAN1.0.1,Temp_Humi03,温湿度传感器,1,1,4793000,0,0
            </code>
          </td>
        </tr>
      </tbody>
    );
  }

  static renderABPEnHelp() {
    return (
      <tbody>
        <tr>
          <td>deveui</td>
          <td>Hexadecimal string of length 16</td>
          <td>Mandatory</td>
          <td>DevEUI</td>
        </tr>
        <tr>
          <td>devaddr</td>
          <td>Hexadecimal string of length 8</td>
          <td>Mandatory</td>
          <td>Device LoRaWAN Address</td>
        </tr>
        <tr>
          <td>nwkskey</td>
          <td>Hexadecimal strong length 32</td>
          <td>Mandatory</td>
          <td>
            <strong>N</strong>et<strong>w</strong>or<strong>k</strong>{" "}
            <strong>S</strong>ession <strong>Key</strong>
          </td>
        </tr>
        <tr>
          <td>appskey</td>
          <td>Hexadecimal string of length 32</td>
          <td>Mandatory</td>
          <td>
            <strong>App</strong> <strong>S</strong>ession <strong>Key</strong>
          </td>
        </tr>
        <tr className={styles.new}>
          <td>
            band <strong className={styles.new}>New!</strong>
          </td>
          <td>
            <ul className="list-unstyled">
              <li>CN470</li>
              <li>US902</li>
              <li>AU915</li>
              <li>EU863</li>
              <li>EU868SEMTECH</li>
              <li>CN470PREQUEL</li>
              <li>AS923</li>
            </ul>
          </td>
          <td>Mandatory</td>
          <td>ISM Band</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendor <strong className={styles.new}>New!</strong>
          </td>
          <td>integer</td>
          <td>Optional</td>
          <td>Vendor ID,Ranges 0~255</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendorver <strong className={styles.new}>New!</strong>
          </td>
          <td>integer</td>
          <td>Optional</td>
          <td>Vendor version,Ranges 0~255</td>
        </tr>
        <tr>
          <td>city</td>
          <td>string</td>
          <td>Optional</td>
          <td>city</td>
        </tr>
        <tr>
          <td>area</td>
          <td>string</td>
          <td>Optioanl</td>
          <td>area</td>
        </tr>
        <tr>
          <td>address</td>
          <td>string</td>
          <td>Optional</td>
          <td>address</td>
        </tr>
        <tr>
          <td>lng</td>
          <td>string</td>
          <td>Optional</td>
          <td>logitude(-180.000000 ~ +180.000000)</td>
        </tr>
        <tr>
          <td>lat</td>
          <td>string</td>
          <td>Optional</td>
          <td>latitude(-90.000000 ~ +90.000000)</td>
        </tr>
        <tr>
          <td>class</td>
          <td>string</td>
          <td>Optional</td>
          <td>LoRaWAN class A</td>
        </tr>
        <tr>
          <td>lwanver</td>
          <td>string</td>
          <td>Optional</td>
          <td>LoRaWAN version, LoRaWAN 1.0.1</td>
        </tr>
        <tr>
          <td>rxwindow</td>
          <td>number</td>
          <td>Optional</td>
          <td>RX window selection</td>
        </tr>
        <tr>
          <td>name</td>
          <td>string</td>
          <td>Optional</td>
          <td>Device name</td>
        </tr>
        <tr>
          <td>type</td>
          <td>string</td>
          <td>Optional</td>
          <td>Temperature and humidity sensor</td>
        </tr>
        <tr>
          <td>rx2dr</td>
          <td>number</td>
          <td>Optional</td>
          <td>RX2DR</td>
        </tr>
        <tr>
          <td>rx2freq</td>
          <td>number</td>
          <td>Optional</td>
          <td>RX2 Frequency, In HZ/100</td>
        </tr>
        <tr>
          <td colSpan={4}>
            <h4>Example CSV File</h4>
            <code>
              deveui,devaddr,nwkskey,appskey,
              <strong className={styles.new}>band</strong>,city,area,address,
              lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver
              <br />
              9876987423569874,11169874,13569874235698742356987423569874,
              13569874235698742356987423569874,
              <strong className={styles.new}>CN470</strong>,
              Shenzhen,Nanshan,HiTechPark,23,25,A,LoRaWAN1.0.1,
              Temp_Humi03,TemperatureHumiditySensor,1,1,4793000,0,0
            </code>
          </td>
        </tr>
      </tbody>
    );
  }

  static renderOTAAZhHelp() {
    return (
      <tbody>
        <tr>
          <td>deveui</td>
          <td>16位16进制</td>
          <td>必选</td>
          <td>终端EUI</td>
        </tr>
        <tr>
          <td>appkey</td>
          <td>32位16进制</td>
          <td>必选</td>
          <td>
            <strong>App</strong> <strong>Key</strong>
          </td>
        </tr>
        <tr className={styles.new}>
          <td>
            band <strong className={styles.new}>新增!</strong>{" "}
          </td>
          <td>
            <ul className="list-unstyled">
              <li>CN470</li>
              <li>US902</li>
              <li>AU915</li>
              <li>EU863</li>
              <li>EU868SEMTECH</li>
              <li>CN470PREQUEL</li>
              <li>AS923</li>
            </ul>
          </td>
          <td>必选</td>
          <td>ISM频段</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendor <strong className={styles.new}>新增!</strong>{" "}
          </td>
          <td>整数</td>
          <td>可选</td>
          <td>厂商ID，范围0~255</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendorver <strong className={styles.new}>新增!</strong>{" "}
          </td>
          <td>整数</td>
          <td>可选</td>
          <td>厂商版本，范围0~255</td>
        </tr>
        <tr>
          <td>city</td>
          <td>string</td>
          <td>可选</td>
          <td>城市</td>
        </tr>
        <tr>
          <td>area</td>
          <td>string</td>
          <td>可选</td>
          <td>区域</td>
        </tr>
        <tr>
          <td>address</td>
          <td>string</td>
          <td>可选</td>
          <td>具体的地址</td>
        </tr>
        <tr>
          <td>lng</td>
          <td>string</td>
          <td>可选</td>
          <td>经度(-180.000000 ~ +180.000000)</td>
        </tr>
        <tr>
          <td>lat</td>
          <td>string</td>
          <td>可选</td>
          <td>纬度(-90.000000 ~ +90.000000)</td>
        </tr>
        <tr>
          <td>class</td>
          <td>string</td>
          <td>可选</td>
          <td>终端类型, A</td>
        </tr>
        <tr>
          <td>lwanver</td>
          <td>string</td>
          <td>可选</td>
          <td>协议版本, LoRaWAN 1.0.1</td>
        </tr>
        <tr>
          <td>rxwindow</td>
          <td>number</td>
          <td>可选</td>
          <td>下行链路RX窗口选择 取值 1或2代表RX1或RX2</td>
        </tr>
        <tr>
          <td>name</td>
          <td>string</td>
          <td>可选</td>
          <td>设备名称</td>
        </tr>
        <tr>
          <td>type</td>
          <td>string</td>
          <td>可选</td>
          <td>前端app解释，温湿度传感器</td>
        </tr>
        <tr>
          <td>rx2dr</td>
          <td>number</td>
          <td>可选</td>
          <td>rx2速率</td>
        </tr>
        <tr>
          <td>rx2freq</td>
          <td>number</td>
          <td>可选</td>
          <td>rx2频点, 单位HZ/100</td>
        </tr>
        <tr>
          <td colSpan={4}>
            <h4>导入csv文件内容示例</h4>
            <code>
              deveui,appkey,
              <strong className={styles.new}>band</strong>,
              city,area,address,lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver{" "}
              <br />
              1234567812345678,12345678123456781234567812345678,
              <strogn className={styles.new}>CN470</strogn>,
              深圳,南山,科技园,23,25,A,LoRaWAN1.0.1,Temp_Humi03,温湿度传感器,1,1,4793000,0,0
            </code>
          </td>
        </tr>
      </tbody>
    );
  }

  static renderOTAAEnHelp() {
    return (
      <tbody>
        <tr>
          <td>deveui</td>
          <td>Hexadecimal string of length 16</td>
          <td>Mandatory</td>
          <td>DevEUI</td>
        </tr>
        <tr>
          <td>appkey</td>
          <td>Hexadecimal string of length 32</td>
          <td>Mandatory</td>
          <td>
            <strong>App</strong> <strong>Key</strong>
          </td>
        </tr>
        <tr className={styles.new}>
          <td>
            band <strong className={styles.new}>New!</strong>
          </td>
          <td>
            <ul className="list-unstyled">
              <li>CN470</li>
              <li>US902</li>
              <li>AU915</li>
              <li>EU863</li>
              <li>EU868SEMTECH</li>
              <li>CN470PREQUEL</li>
              <li>AS923</li>
            </ul>
          </td>
          <td>Mandatory</td>
          <td>ISM Band</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendor <strong className={styles.new}>New!</strong>
          </td>
          <td>integer</td>
          <td>Optional</td>
          <td>Vendor ID,Ranges 0~255</td>
        </tr>
        <tr className={styles.new}>
          <td>
            vendorver <strong className={styles.new}>New!</strong>
          </td>
          <td>integer</td>
          <td>Optional</td>
          <td>Vendor version,Ranges 0~255</td>
        </tr>
        <tr>
          <td>city</td>
          <td>string</td>
          <td>Optional</td>
          <td>city</td>
        </tr>
        <tr>
          <td>area</td>
          <td>string</td>
          <td>Optional</td>
          <td>area</td>
        </tr>
        <tr>
          <td>address</td>
          <td>string</td>
          <td>Optional</td>
          <td>address</td>
        </tr>
        <tr>
          <td>lng</td>
          <td>string</td>
          <td>Optional</td>
          <td>logitude(-180.000000 ~ +180.000000)</td>
        </tr>
        <tr>
          <td>lat</td>
          <td>string</td>
          <td>Optional</td>
          <td>latitude(-90.000000 ~ +90.000000)</td>
        </tr>
        <tr>
          <td>class</td>
          <td>string</td>
          <td>Optional</td>
          <td>LoRaWAN class A</td>
        </tr>
        <tr>
          <td>lwanver</td>
          <td>string</td>
          <td>Optional</td>
          <td>LoRaWAN version, LoRaWAN 1.0.1</td>
        </tr>
        <tr>
          <td>rxwindow</td>
          <td>number</td>
          <td>Optional</td>
          <td>RX window selection</td>
        </tr>
        <tr>
          <td>name</td>
          <td>string</td>
          <td>Optional</td>
          <td>Device name</td>
        </tr>
        <tr>
          <td>type</td>
          <td>string</td>
          <td>Optional</td>
          <td>app解释，温湿度传感器</td>
        </tr>
        <tr>
          <td>rx2dr</td>
          <td>number</td>
          <td>Optional</td>
          <td>RX2DR</td>
        </tr>
        <tr>
          <td>rx2freq</td>
          <td>number</td>
          <td>Optional</td>
          <td>RX2 Frequency, In HZ/100</td>
        </tr>
        <tr>
          <td colSpan={4}>
            <h4>Example CSV File</h4>
            <code>
              deveui,appkey,
              <strong className={styles.new}>band</strong>,
              city,area,address,lng,lat,class,lwanver,name,type,rxwindow,rx2dr,rx2freq,vendor,vendorver{" "}
              <br />
              1234567812345678,12345678123456781234567812345678,
              <strong className={styles.new}>CN470</strong>,
              Shenzhen,Nanshan,HiTechPark,23,25,A,
              LoRaWAN1.0.1,Temp_Humi03,TemperatureHumiditySensor,1,1,4793000,0,0
            </code>
          </td>
        </tr>
      </tbody>
    );
  }

  static norm(rows) {
    let normedRows = _.filter(rows, (r) => r.deveui.trim().length > 0);
    normedRows = _.map(normedRows, (r, idx) => {
      let row = { ...r };
      row.idx = idx;
      row.missings = _.filter(
        kRequiredFields,
        (f) => !_.has(row, f) || _.isNil(row[f]) || row[f].trim() === ""
      );
      row.valid = row.missings.length === 0;
      row.error = null;
      row = _.mapKeys(row, (value, key) => key.toLowerCase());
      return row;
    });
    return normedRows;
  }

  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      basic: props.basic,
      plan: props.plan,
      usage: props.usage,
      activeKey: 1,
      view: "dropzone",
      encoding: "UTF-8",
    };
    this.intlMsg = new IntlMsg(props.intl, "applicationdetail.batchimport");
    this.handleDrop = this.handleDrop.bind(this);
    this.handleReImport = this.handleReImport.bind(this);
    this.handleChangeEncoding = this.handleChangeEncoding.bind(this);
    this.handleSubmitImport = this.handleSubmitImport.bind(this);
    this.toggleCheck = this.toggleCheck.bind(this);
    this.toggleCheckAll = this.toggleCheckAll.bind(this);
    this.handleSelectHelp = this.handleSelectHelp.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { app, basic, plan, usage } = nextProps;
    if (app !== this.props.app) {
      this.setState({ app });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage });
    }
  }

  cleanse(rows) {
    return _.map(rows, (r) => {
      r.lastact = 0;
      let nr = { ...r, deveui: r.deveui.trim() };
      if (_.has(nr, "rxwindow")) {
        nr = { ...nr, rxwindow: Number(r.rxwindow) };
      }
      if (_.has(nr, "devaddr")) {
        nr = { ...nr, devaddr: nr.devaddr.trim() };
      }
      if (_.has(nr, "nwkskey")) {
        nr = { ...nr, nwkskey: nr.nwkskey.trim() };
      }
      if (_.has(nr, "appskey")) {
        nr = { ...nr, appskey: nr.appskey.trim() };
      }
      if (_.has(nr, "appkey")) {
        nr = { ...nr, appkey: nr.appkey.trim() };
      }
      if (_.has(nr, "rx2dr")) {
        nr = { ...nr, rx2dr: Number(r.rx2dr) };
      }
      if (_.has(nr, "rx2freq")) {
        nr = { ...nr, rx2freq: Number(r.rx2freq) };
      }
      if (_.has(nr, "vendor")) {
        nr.vendor = Number(r.vendor);
      }
      if (_.has(nr, "vendorver")) {
        nr.vendorver = Number(r.vendorver);
      }
      let canSubmit = true;
      _.forEach(Object.keys(validateFields), (f) => {
        if (_.has(nr, f) && nr[f] && !validateFields[f](nr[f])) {
          nr.error = true;
          canSubmit = false;
        }
      });
      this.setState({ canSubmit });
      return nr;
    });
  }

  handleDrop(acceptedFiles) {
    if (acceptedFiles.length > 0) {
      this.setState({ file: acceptedFiles[0] });
      this.prepareFile({ file: acceptedFiles[0] });
    }
  }

  appName() {
    const { appId } = this.props;
    const { app } = this.state;
    if (app.status === "success") {
      return app.data.name || appId;
    }
    return <i className="fa fa-spinner fa-spin" />;
  }

  handleSelectHelp(activeKey) {
    this.setState({ activeKey });
  }

  prepareFile(options) {
    const { file = this.state.file, encoding = this.state.encoding } = options;
    if (!file) {
      return;
    }

    const that = this;
    Papa.parse(file, {
      complete: (result) => {
        let rows = BatchImport.norm(result.data);
        // rows = _.filter(rows, { valid: true });
        rows = this.cleanse(rows);
        that.setState({
          rows,
          checkedRows: _.filter(rows, "valid"),
          view: "preview",
        });
      },
      header: true,
      encoding,
    });
  }

  handleChangeEncoding(encoding) {
    this.setState({ encoding });
    this.prepareFile({ encoding });
  }

  handleSubmitImport() {
    const { appId } = this.props;
    const {
      checkedRows,
      basic: { data: { lrnodenum } = {} },
      usage: { nodes: ncnts = 0 },
      canSubmit = true,
    } = this.state;
    let rows = this.state.rows;
    if (!canSubmit) {
      return;
    }

    if (ncnts + checkedRows.length > lrnodenum) {
      this.setState({ error: "ooq" });
      return;
    }

    // !!! Oh yeah, we can do the batch import !!!!
    importBatch({ list: checkedRows }, appId)
      .then((resp) => {
        _.forEach(_.zip(checkedRows, resp.body.list), (p) => {
          const idx = p[0].idx;
          rows = _.map(rows, (r) => {
            if (r.idx === idx) {
              return { ...r, result: p[1] };
            }
            return r;
          });
        });
        this.setState({
          rows,
          view: "result",
        });
      })
      .catch((reason) => {
        let code = "UNKNOWN";
        if (reason && reason.body) {
          code = reason.body._code; // eslint-disable-line
        }
        if (code === "DEVADDRUNAVAIL") {
          this.setState({ error: "DEVADDRUNAVAIL" });
        }
        if (code === "QUOTA") {
          this.setState({ error: "ooq" });
        }
      });
  }

  handleReImport() {
    const { getNodesUsage } = this.props;
    getNodesUsage();
    this.setState({
      view: "dropzone",
      file: null,
    });
  }

  toggleCheck(row) {
    const { checkedRows } = this.state;
    if (_.some(checkedRows, { idx: row.idx })) {
      this.setState({
        checkedRows: _.filter(checkedRows, (r) => r.idx !== row.idx),
      });
    } else {
      checkedRows.push(row);
      this.setState({ checkedRows });
    }
  }

  toggleCheckAll() {
    const { rows, checkedRows } = this.state;
    const validRows = _.filter(rows, "valid");
    if (validRows.length === checkedRows.length) {
      this.setState({ checkedRows: [] });
    } else {
      this.setState({ checkedRows: validRows });
    }
  }

  parseResultError(x) {
    if (startsWith(x, "DEVEUIUNAVAIL")) {
      return this.intlMsg.errorMsg("DEVEUIUNAVAIL");
    } else if (startsWith(x, "BADDEVEUI")) {
      return this.intlMsg.errorMsg("BADDEVEUI");
    } else if (startsWith(x, "DEVEUICONFLICT")) {
      return this.intlMsg.errorMsg("DEVEUICONFLICT");
    } else if (startsWith(x, "BANDUNKNOWN")) {
      return this.intlMsg.errorMsg("BANDUNKNOWN");
    } else if (startsWith(x, "DEVADDRUNAVAIL")) {
      return this.intlMsg.errorMsg("DEVADDRUNAVAIL");
    }
    return `${this.intlMsg.msg("result.fail")}: ${x}`;
  }

  renderTools() {
    const { encoding } = this.state;
    return (
      <div className={styles.tools}>
        <InlineSelect
          options={kEncodingOptions}
          onChange={(xs) => this.handleChangeEncoding(xs[0])}
          values={[encoding]}
        />
      </div>
    );
  }

  renderDropzone() {
    return (
      <div>
        {this.renderTools()}
        <Dropzone
          className={styles.dropzone}
          activeClassName={styles["dropzone-active"]}
          onDrop={this.handleDrop}
        >
          <div className="text-center">{this.intlMsg.msg("dropzone.text")}</div>
        </Dropzone>
      </div>
    );
  }

  renderPreview() {
    const {
      basic,
      usage: { nodes: ncnts = 0 },
      canSubmit = true,
    } = this.state;
    if (basic.status !== "success") {
      return (
        <div styleName="table-loading">
          <i className="fa fa-spinner fa-spin fa-3x" />
        </div>
      );
    }

    const { rows, checkedRows } = this.state;
    let headers = _.union(_.flatten(_.map(rows, (r) => _.keys(r))));
    headers = _.filter(
      headers,
      (h) => !kInnerFields.includes(h) && !kRequiredFields.includes(h)
    );
    headers = _.concat(kRequiredFields, headers);

    const ths = headers.map((h) => (
      <th key={h} style={{ whiteSpace: "nowrap" }}>
        {h}
      </th>
    ));
    const trs = rows.map((r) => (
      <tr key={r.deveui} styleName={r.error ? "result-fail" : ""}>
        <td styleName="f-checkbox">
          {r.error ? (
            <i className="fa fa-times" />
          ) : (
            <Checkbox
              id={r.deveui}
              checked={_.some(checkedRows, { idx: r.idx })}
              onChange={() => this.toggleCheck(r)}
              disabled={!r.valid}
            />
          )}
        </td>
        {headers.map((h) => {
          let c;
          let sty = "";
          if (r.missings.includes(h)) {
            c = this.intlMsg.msg("preview.required");
          } else if (_.has(validateFields, h) && !validateFields[h](r[h])) {
            c = `${this.intlMsg.msg("preview.invalidvalue")}: ${r[h]}`;
            sty = "invalid";
          } else {
            c = r[h];
          }
          return (
            <td
              key={`${r.deveui}-${h}`}
              className={r.missings.includes(h) ? styles.missing : ""}
              style={{ whiteSpace: "nowrap" }}
              styleName={sty}
            >
              {c}
            </td>
          );
        })}
      </tr>
    ));

    const {
      data: { lrnodenum },
    } = basic;

    return (
      <div styleName="preview">
        {this.renderTools()}
        <Table className="aisz-table-light" striped responsive bordered hover>
          <thead>
            <tr>
              <th styleName="f-checkbox">
                <Checkbox
                  id="all"
                  checked={
                    _.filter(rows, "valid").length === checkedRows.length
                  }
                  onChange={this.toggleCheckAll}
                />
              </th>
              {ths}
            </tr>
          </thead>
          <tbody>{trs}</tbody>
        </Table>
        <div styleName="tips">
          {this.intlMsg.msg("preview.canimport.tips.desc1")}
          <strong>{lrnodenum}</strong>
          {this.intlMsg.msg("preview.canimport.tips.desc2")}
          <strong>{ncnts}</strong>
          {this.intlMsg.msg("preview.canimport.tips.desc3")}
          <strong>{lrnodenum - ncnts}</strong>
          {this.intlMsg.msg("preview.canimport.tips.desc4")}
        </div>
        <div styleName="submit">
          <Button
            bsStyle="aisz-warning"
            onClick={() => this.setState({ view: "dropzone" })}
          >
            <i className="fa fa-repeat" />{" "}
            {this.intlMsg.msg("preview.cancel.btn")}
          </Button>{" "}
          <Button
            bsStyle="aisz-primary"
            onClick={this.handleSubmitImport}
            disabled={checkedRows.length === 0 || !canSubmit}
          >
            {this.intlMsg.msg("preview.import.btn.seg1")}{" "}
            <Badge bsClass="aisz-badge-primary-i">{checkedRows.length}</Badge>{" "}
            {this.intlMsg.msg("preview.import.btn.seg2")}{" "}
            <i className="fa fa-arrow-circle-o-right" />
          </Button>
        </div>
      </div>
    );
  }

  renderResult() {
    const { appId } = this.props;
    const { rows } = this.state;
    let headers = _.union(_.flatten(_.map(rows, (r) => _.keys(r))));
    headers = _.filter(headers, (h) => !kInnerFields.includes(h));
    const ths = headers.map((h, i) => (
      <th key={i} style={{ whiteSpace: "nowrap" }}>
        {h}
      </th>
    )); // eslint-disable-line
    const trs = rows.map((r, i) => {
      let status = "notimport";
      let icon;
      let msg = this.intlMsg.msg("result.notimport");
      if (_.has(r, "result")) {
        status = r.result === "OK" ? "succ" : "fail";
        if (status === "succ") {
          icon = <i className="fa fa-check" />;
          msg = this.intlMsg.msg("result.succ");
        } else {
          icon = <i className="fa fa-times" />;
          msg = this.parseResultError(r.result, r);
        }
      }
      return (
        <tr key={String(i)} styleName={`result-${status}`}>
          <td style={{ whiteSpace: "nowrap" }}>{icon}</td>
          <td style={{ whiteSpace: "nowrap" }}>{msg}</td>
          {headers.map((h, idx) => (
            <td key={idx} style={{ whiteSpace: "nowrap" }}>
              {r[h]}
            </td> // eslint-disable-line
          ))}
        </tr>
      );
    });

    const succCount = _.filter(
      rows,
      (r) => _.has(r, "result") && r.result === "OK"
    ).length;
    const failCount = _.filter(
      rows,
      (r) => _.has(r, "result") && r.result !== "OK"
    ).length;

    return (
      <div>
        <Table className="aisz-table-light" responsive bordered>
          <thead>
            <tr>
              <th />
              <th>{this.intlMsg.msg("result.thead.status")}</th>
              {ths}
            </tr>
          </thead>
          <tbody>{trs}</tbody>
        </Table>
        <div styleName="result-summary">
          {this.intlMsg.msg("result.summary.seg1")}
          {": "}
          {succCount}, {this.intlMsg.msg("result.summary.seg2")}
          {": "}
          {failCount},{" "}
          <Link onClick={this.handleReImport}>
            {this.intlMsg.msg("result.summary.reimport")}
          </Link>{" "}
          <Link
            onClick={() => this.props.pushState(`/application/${appId}/detail`)}
          >
            {this.intlMsg.msg("result.summary.back")}
          </Link>
        </div>
      </div>
    );
  }

  renderHelp() {
    if (this.state.activeKey === 1) {
      return (
        <div styleName="helpdoc">
          <Table className="aisz-table-light" responsive hover>
            <thead>
              <tr>
                <th>{this.intlMsg.msg("help.abp.thead.fieldname")}</th>
                <th>{this.intlMsg.msg("help.abp.thead.length")}</th>
                <th>{this.intlMsg.msg("help.abp.thead.mandatory")}</th>
                <th>{this.intlMsg.msg("help.abp.thead.remark")}</th>
              </tr>
            </thead>
            {this.props.intl.locale === "zh"
              ? BatchImport.renderABPZhHelp()
              : BatchImport.renderABPEnHelp()}
          </Table>
        </div>
      );
    }
    return (
      <div styleName="helpdoc">
        <Table className="aisz-table-light" responsive hover>
          <thead>
            <tr>
              <th>{this.intlMsg.msg("help.abp.thead.fieldname")}</th>
              <th>{this.intlMsg.msg("help.abp.thead.length")}</th>
              <th>{this.intlMsg.msg("help.abp.thead.mandatory")}</th>
              <th>{this.intlMsg.msg("help.abp.thead.remark")}</th>
            </tr>
          </thead>
          {this.props.intl.locale === "zh"
            ? BatchImport.renderOTAAZhHelp()
            : BatchImport.renderOTAAEnHelp()}
        </Table>
      </div>
    );
  }

  renderErrorModal() {
    const { error, plan } = this.state;
    let errorContent = null;
    if (error === "ooq") {
      if (plan.status !== "success") {
        errorContent = this.intlMsg.msg("device.err.outofquota", "lora");
      } else {
        errorContent = (
          <div>
            <HideIf if="profile:cube">
              <div>
                <ShowIf if={plan.data.tier < 3}>
                  <div>
                    <p>{this.intlMsg.msg("err.outofquota.undercomm")}</p>
                    <Button
                      bsStyle="aisz-primary"
                      onClick={() => this.props.pushState("/billing/plans")}
                    >
                      {this.intlMsg.msg("upgrade.btn")}{" "}
                      <i className="fa fa-arrow-circle-o-right" />
                    </Button>
                  </div>
                </ShowIf>
                <ShowIf if={plan.data.tier === 3}>
                  <div>
                    {this.intlMsg.msg("err.outofquota.comm")}
                    <br />
                    <a href="mailto:support@aisenz.com">support@aisenz.com</a>
                  </div>
                </ShowIf>
              </div>
            </HideIf>
            <ShowIf if="profile:cube">
              <div>
                {this.intlMsg.msg("err.outofquota.cube")}
                <br />
                <a href="mailto:support@aisenz.com">support@aisenz.com</a>
              </div>
            </ShowIf>
          </div>
        );
      }
    } else if (error === "DEVADDRUNAVAIL") {
      errorContent = this.intlMsg.msg("E.DEVADDRUNAVAIL");
    }

    return (
      <Modal
        bsClass="aisz-modal-warning"
        show={!_.isNil(this.state.error)}
        onHide={() => this.setState({ error: null })}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" />{" "}
            {this.intlMsg.msg("err.modalheader")}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">{errorContent}</div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const { appId } = this.props;
    const breadcrumb = [
      {
        content: <FormattedMessage id="application.breadcrumb.application" />,
        onClick: () => this.props.pushState("/application"),
      },
      {
        content: this.appName(),
        onClick: () => this.props.pushState(`/application/${appId}/detail`),
      },
      {
        content: (
          <FormattedMessage id="applicationdetail.batchimport.breadcrumb" />
        ),
        active: true,
      },
    ];

    const helpHeader = (
      <span>
        <i className="fa fa-book" /> {this.intlMsg.msg("help.panelheader")}
      </span>
    );

    const { view, activeKey } = this.state;

    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Toolbar breadcrumb={breadcrumb} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Panel bsStyle="aisz-white">
                {view === "dropzone" && this.renderDropzone()}
                {view === "preview" && this.renderPreview()}
                {view === "result" && this.renderResult()}
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Panel bsStyle="aisz-white" header={helpHeader}>
                <Nav
                  bsStyle="aisz-pills"
                  activeKey={activeKey}
                  onSelect={this.handleSelectHelp}
                >
                  <NavItem eventKey={1} onClick={() => {}}>
                    {this.intlMsg.msg("help.abp")}
                  </NavItem>
                  <NavItem eventKey={2} onClick={() => {}}>
                    {this.intlMsg.msg("help.otaa")}
                  </NavItem>
                </Nav>
                {this.renderHelp()}
              </Panel>
            </Col>
          </Row>
        </Grid>
        <div>{this.renderErrorModal()}</div>
      </div>
    );
  }
}

BatchImport.defaultProps = defaultProps;
BatchImport.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  basic: state.org.basic,
  plan: state.billing.plan,
  usage: state.usage,
  app: state.app.getApp,
  appId: ownProps.params.id,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getNodesUsage: usageActions.nodes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(CSSModules(BatchImport, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BatchImport/index.jsx